export const getNodeChildItemCount = (nodeItem) =>
  nodeItem?.node?.category?.childItemCount ||
  nodeItem?.node?.group?.childItemCount ||
  0;
export const getNodeId = (nodeItem) => nodeItem?.node?.id;
export const getNodeType = (nodeItem) => nodeItem?.node?.type;
